// Blueprint: forge/blueprint/frontend/architecture/001-shell-composition.md
import { symbolToken } from '@servicetitan/react-ioc';

/** Resolved root org id for registry reads and child-module mount data. `null` → AppStore fail-closes. */
export const RootOrgIdToken = symbolToken<string | null>('RootOrgId');

/** Host-specific settings merged over every child module's registry `settings`; the host wins. */
export type ModuleSettingsOverride = Readonly<Record<string, string>>;

export const ModuleSettingsOverrideToken =
    symbolToken<ModuleSettingsOverride>('ModuleSettingsOverride');
